import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { axios } from '@repo/http';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const teamQuery = createQueryKeys('team', {
    getById: (teamId)=>({
            queryKey: [
                'team',
                teamId
            ],
            queryFn: ()=>{
                if (!teamId) {
                    return null;
                }
                return axios.get("/v2/team/".concat(teamId)).then((res)=>res.data.value);
            }
        }),
    getByOrganizationIdAndName: (organization, team)=>({
            queryKey: [
                'teamAndOrganization',
                organization,
                team
            ],
            queryFn: ()=>{
                if (!team || !organization) {
                    return null;
                }
                return axios.get("/v2/team/".concat(organization, "/team/").concat(team)).then((res)=>res.data.value);
            }
        })
});
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useOrganizationTeam(organizationName, teamName) {
    const { isLoading, data: team, error } = useQuery(teamQuery.getByOrganizationIdAndName(organizationName, teamName));
    return {
        team,
        isLoading,
        error
    };
}
